import View from 'ln/view/View';
import { ISlide } from 'typescript/src/course/slideview/SlideDetailView';
import SlideDetailView from '../../course/slideview/SlideDetailView';

class MediaSearchSlideView extends View{

    public constructor( public slide: ISlide ) {
        super( { slide:slide } );

        // hack for slidedetails
        this.data.slide.courseversion = '';
        this.data.slide.startdate = new Date().toISOString();
        this.data.slide.pagenumber = '';

        this.defaultTemplate = 'krw.mediasearch-sequence-slide';
    }

    init(){
        var detail = new SlideDetailView();
        detail.setSlide( this.data.slide );
        detail.render();
        this.node.js( 'preview' ).append( detail.node );
    }

}

export default MediaSearchSlideView;